import { render, staticRenderFns } from "./date-time-picker-type-editor.vue?vue&type=template&id=167f8f7c&scoped=true"
import script from "./date-time-picker-type-editor.vue?vue&type=script&lang=js"
export * from "./date-time-picker-type-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f8f7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167f8f7c')) {
      api.createRecord('167f8f7c', component.options)
    } else {
      api.reload('167f8f7c', component.options)
    }
    module.hot.accept("./date-time-picker-type-editor.vue?vue&type=template&id=167f8f7c&scoped=true", function () {
      api.rerender('167f8f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-date-time-picker/date-time-picker-type-editor.vue"
export default component.exports